import { render } from "./IconExternalLink.vue?vue&type=template&id=33877bc6&ts=true"
import script from "./IconExternalLink.vue?vue&type=script&lang=ts"
export * from "./IconExternalLink.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/paulbele/Code/repositories/maatoo-app-master/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__